import React from 'react'
import img1 from "../../Assets/images/campus11.png"
import img2 from "../../Assets/images/campus2.png"
import img3 from "../../Assets/images/campus3.png"
const Campuses = () => {
  return (
    <>
    <section className='section-top-padding section-bottom-padding access-card-main'>
        <div className='container'>
            <div className="mp-banner-content text-center mw-100">
                <h2 className='heading-title'>
                    Get Discovered by Top 
                    <span className='gr-txt'>Companies, Faster</span>
                </h2>
                <p>
                </p>
            </div>
            <div className='row condidate-access-card'>
              <div className='col-6 col-lg-4 mb-3 mb-lg-0'>
                  <div className='access-card d-block soft-pink'>
                      <div className='access-card-header'>
                        <h2 className='p-0'>Skills First</h2>
                        <p>Recruiters see your video profile & real-world assignments, not just resumes.</p>
                      </div>
                      <img src={img1} className='rounded-5' alt=''/>
                  </div>
              </div>
              <div className='col-6 col-lg-4 mb-3 mb-lg-0'>
                  <div className='access-card d-block soft-blue'>
                      <div className='access-card-header'>
                        <h2 className='p-0'>Verified Opportunities</h2>
                        <p>Only pre-screened companies with active hiring.</p>
                      </div>
                      <img src={img2} className='rounded-5' alt=''/>
                  </div>
              </div>
              <div className='col-12 col-lg-4 mb-3 mb-lg-0'>
                  <div className='access-card flex-row d-lg-block soft-pink'>
                      <div className='access-card-header'>
                        <h2 className='p-0'>Pan-India Reach</h2>
                        <p>Apply to companies across 500+ companies without travel or logistics hassle.</p>
                      </div>
                      <img src={img3} className='rounded-5 m-auto fit-img-width' alt=''/>
                  </div>
              </div>
            </div>
        </div>
      </section>
    </>
  )
}

export default Campuses